import { Card, Typography } from '@mui/joy';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { FormattedChatHistoryItem } from '../../../interfaces/message';
import useAINavigation from '../../../hooks/navigation';

interface IHistoryCard {
	historicalChat: FormattedChatHistoryItem;
}

function getMessageText(
	message:
		| FormattedChatHistoryItem['last_model_message']
		| FormattedChatHistoryItem['last_user_message'],
) {
	if (!message?.content?.parts?.length) return '';
	if ('text' in message?.content?.parts[0] && message?.content?.parts[0].text)
		return message?.content?.parts[0].text;
	return '📎 File attached';
}

const HistoryCard = ({ historicalChat }: IHistoryCard) => {
	const {
		chat_id,
		last_user_message,
		last_model_message,
		last_updated_relative,
	} = historicalChat;
	const { navigateTo } = useAINavigation();
	return (
		<Card
			onClick={() => navigateTo(`/c/${chat_id}`)}
			sx={{
				padding: 2,
				variant: 'outlined',
				height: 130,
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-between',
				overflow: 'hidden',
			}}
		>
			<Typography
				level='title-sm'
				sx={{
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
				}}
			>
				{getMessageText(last_user_message)}
			</Typography>

			<Typography
				sx={{
					fontSize: 12,
					display: '-webkit-box',
					WebkitLineClamp: 3,
					WebkitBoxOrient: 'vertical',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					mt: 0.5,
					flexGrow: 1, // fill available vertical space
				}}
			>
				{getMessageText(last_model_message)}
			</Typography>

			<Typography
				textColor='text.tertiary'
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: 0.5,
					fontSize: 10,
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					mt: 0.5,
				}}
			>
				<AccessTimeIcon sx={{ fontSize: 14 }} />
				{last_updated_relative}
			</Typography>
		</Card>
	);
};

export default HistoryCard;
